import { Typography } from '@mui/material'

type SectionSubtitleProps = { label: string }

export const SectionSubtitle = ({ label }: SectionSubtitleProps) => {
  return <Typography variant='subtitle2'>{label}</Typography>
}
